import config from "./config";
 
export const msalConfig = {
  auth: {
    clientId: config.AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${config.AZURE_TENANT_ID}`,
    redirectUri: `${config.REDIRECT_URL}`,
    postLogoutRedirectUri: `${config.POSTREDIRECT_URL}`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};